import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/Kitab.css";

const KitabStrip = ({ kitabs = [], selectedKitabId = null, onSelect }) => {
    const navigate = useNavigate();

    // ✅ assets dari public/
    const bookIcon = `${process.env.PUBLIC_URL}/assets/book.png`;
    const bookIconHover = `${process.env.PUBLIC_URL}/assets/book-hover.png`;

    const items = useMemo(() => {
        return [...kitabs].map((k) => ({
            id: k.id,
            title: k.title || k.name || k.id,
            coverImage: k.coverImage || "",
            category: k.category || "",
            author: k.author || "",
            raw: k,
        }));
    }, [kitabs]);

    const openKitabPage = () => {
        if (selectedKitabId) return navigate(`/kitab/${selectedKitabId}`);
        navigate("/kitab");
    };

    return (
        <div className="kitab-strip-wrap">
            <div className="kitab-strip">
                {items.map((k) => (
                    <button
                        key={k.id}
                        className={`kitab-chip ${selectedKitabId === k.id ? "active" : ""}`}
                        onClick={() => onSelect?.(k.raw)}
                        type="button"
                    >
                        {k.coverImage ? (
                            <img
                                className="kitab-chip-cover"
                                src={k.coverImage}
                                alt={k.title}
                                onError={(e) => (e.currentTarget.style.display = "none")}
                            />
                        ) : (
                            <div className="kitab-chip-cover fallback" />
                        )}

                        <div className="kitab-chip-text">
                            <div className="kitab-chip-title">{k.title}</div>
                            <div className="kitab-chip-meta">
                                {k.category || "Umum"}{k.author ? ` • ${k.author}` : ""}
                            </div>
                        </div>
                    </button>
                ))}
            </div>

            {/* ✅ overlay kanan (tak masuk scroll items) */}
            <button
                className="kitab-strip-endbtn"
                type="button"
                onClick={openKitabPage}
                style={{ backgroundImage: `url(${bookIcon})` }}
                onMouseEnter={(e) => (e.currentTarget.style.backgroundImage = `url(${bookIconHover})`)}
                onMouseLeave={(e) => (e.currentTarget.style.backgroundImage = `url(${bookIcon})`)}
                aria-label="Buka halaman Kitab"
                title="Buka halaman Kitab"
            />
        </div>
    );

};

export default KitabStrip;
